import React from 'react';
import { motion, useAnimationControls, useReducedMotion } from 'framer-motion';
import { ChevronDown } from 'lucide-react'; 
import styles from './Hero.module.scss';

import SmartRenderer from '../../../utils/SmartRenderer/SmartRenderer';

const Hero = ({ title, tagline, badges = [], synopsis, onPrimary, onSecondary, primaryLabel, secondaryLabel, onStart, targetId, onCollapse  }) => {
  
    const reduce = useReducedMotion();
    const controls = useAnimationControls();
    const [state, setState] = React.useState('expanded'); // 'expanded' | 'collapsing' | 'collapsed'

    // Variants pour animer hauteur + opacité
    const variants = {
        expanded: { height: 'auto', opacity: 1, transition: { height: { duration: 0 }, opacity: { duration: .3 } } },
        collapsing: {
        height: 0, opacity: 100,
        transition: {
            height: { duration: reduce ? 0 : .55, ease: [0.22, 1, 0.36, 1] },
            opacity: { duration: reduce ? 0 : .25, ease: 'easeOut' }
        }
        }
    };

    const container = {
        hidden: { opacity: 0, y: reduce ? 0 : 12 },
        visible: { opacity: 1, y: 0, transition: { duration: .5 } }
    };

    const list = {
        hidden: {},
        visible: { transition: { staggerChildren: .08 } }
    };

    const item = {
        hidden: { opacity: 0, y: reduce ? 0 : 8 },
        visible: { opacity: 1, y: 0, transition: { duration: .35 } }
    };

    const handleStart = async () => {
        // Optionnel : lance l’action principale immédiatement
        // if (typeof onPrimary === 'function') onPrimary();
        // if (typeof onStart === 'function') onStart();
        // if (targetId) {
        // const el = document.getElementById(targetId);
        // if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        // }

        // Replie le hero
        setState('collapsing');
        await controls.start('collapsing');

        // Notifie le parent quand l’anim est finie
        onCollapse?.();

        // État final (si tu veux le garder démonté)
        setState('collapsed');
    };


    return (
        <motion.section
            className={styles.hero}
            style={{ overflow: 'hidden' }}          // indispensable pour height → 0
            initial="expanded"
            animate={controls}
            variants={variants}
            onUpdate={() => { /* hook dispo si besoin */ }}
        >
            <motion.div
                className={styles.heroContent}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, margin: '-20% 0px -20% 0px' }}
                variants={container}
            >
                <h1><SmartRenderer content={title} /></h1>
                {tagline && <p className={styles.heroTagline}><SmartRenderer content={tagline} /></p>}

                {!!badges.length && (
                <motion.div className={styles.heroBadges} variants={list}>
                    {badges.map((b, i) => (
                    <motion.span key={i} variants={item}>{b}</motion.span>
                    ))}
                </motion.div>
                )}

                <hr className={styles.hr} />

                {synopsis && <p className={styles.heroSynopsis}>{synopsis}</p>}

                {/* <div className={styles.heroCTAs}>
                <motion.button
                    whileHover={{ scale: reduce ? 1 : 1.03 }}
                    whileTap={{ scale: reduce ? 1 : 0.98 }}
                    className={styles.ctaPrimary}
                    onClick={onPrimary}
                >
                    {primaryLabel}
                </motion.button>
                <motion.button
                    whileHover={{ scale: reduce ? 1 : 1.02 }}
                    whileTap={{ scale: reduce ? 1 : 0.98 }}
                    className={styles.ctaSecondary}
                    onClick={onSecondary}
                >
                    {secondaryLabel}
                </motion.button>
                </div> */}
            </motion.div>

            {/* CTA “Démarrer” en bas */}
            <motion.button
                type="button"
                className={styles.startHint}
                onClick={handleStart}
                aria-label="Démarrer"
                initial={reduce ? { opacity: 0.9 } : { y: 0, opacity: 0.9 }}
                animate={reduce ? { opacity: 0.9 } : { y: [0, -6, 0], opacity: 0.9 }}
                transition={reduce ? {} : { duration: 1.4, repeat: Infinity, ease: 'easeInOut' }}
            >
                {/* <span className={styles.startLabel}>Démarrer</span> */}
                <ChevronDown className={styles.startIcon} aria-hidden="true" />
            </motion.button>
        </motion.section>
    );
};

export default Hero;
